/**
 * OrderStatusTimeline.js
 * Shared order status / notes timeline for admin and customer views.
 */

import React from 'react';
import { formatDateAtlantic } from '../utils/dateFormat';
import {
  getTimelineEntries,
  getTimelineEntryIcon,
  getTimelineEntryTitle,
} from '../utils/orderHistoryDisplay';
import './OrderStatusTimeline.css';

const OrderStatusTimeline = ({
  order,
  notesHistory,
  inquiryThread,
  customerView = false,
  hideConversationEntries = false,
  title = 'Order History',
}) => {
  const entries = getTimelineEntries(order, notesHistory, {
    customerView,
    inquiryThread,
    hideConversationEntries,
  });

  return (
    <div className={`order-status-timeline ${customerView ? 'customer-view' : 'admin-view'}`}>
      <h4 className="order-status-timeline-title">
        🕘 {title}
        {entries.length > 0 && (
          <span className="order-status-timeline-count">({entries.length})</span>
        )}
      </h4>

      {entries.length === 0 ? (
        <div className="order-status-timeline-empty">No order history yet.</div>
      ) : (
        <ol className="order-status-timeline-list">
          {entries.map((note, index) => (
            <li
              key={`${note.timestamp || 'entry'}-${index}`}
              className={`order-status-timeline-item ${note.type || 'note'} ${note.sentViaEmail ? 'emailed' : ''}`}
            >
              <div className="order-status-timeline-marker" aria-hidden="true">
                <span className="order-status-timeline-icon">{getTimelineEntryIcon(note)}</span>
              </div>
              <div className="order-status-timeline-content">
                <div className="order-status-timeline-header">
                  <strong className="order-status-timeline-label">
                    {getTimelineEntryTitle(note)}
                  </strong>
                  <span className="order-status-timeline-date">
                    {formatDateAtlantic(note.timestamp)}
                  </span>
                </div>
                {note.message && (
                  <div className="order-status-timeline-message">{note.message}</div>
                )}
                {!customerView && note.payment_status && note.type !== 'refund' && (
                  <div className="order-status-timeline-meta">
                    Payment: {note.payment_status.replace(/_/g, ' ')}
                  </div>
                )}
                {note.sentViaEmail && (
                  <div className="order-status-timeline-email-flag">📧 Emailed to customer</div>
                )}
                {note.type === 'refund' && note.refundAmountFormatted && (
                  <div className="order-status-timeline-refund-amount">
                    Refund amount: {note.refundAmountFormatted}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default OrderStatusTimeline;
